import { get } from "../../data/api";

export async function getListingsMap() {
    return await get("tool/listings-map");
}
